// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.profile-container h1 {
  color: #1e3a5f;
  margin-bottom: 0.3rem;
}

.profile-email {
  color: #6b7280;
  margin-bottom: 1.5rem;
}

.login-prompt {
  text-align: center;
  margin-top: 3rem;
  font-size: 1.1rem;
  color: #6b7280;
}

.login-prompt .link {
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
}

.profile-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
}

.profile-tabs button {
  padding: 0.7rem 1.2rem;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1rem;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.2s;
}

.profile-tabs button.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  font-weight: 600;
}

.profile-tabs button:hover {
  color: #111827;
}

.tab-content {
  min-height: 200px;
}

.empty-text {
  text-align: center;
  color: #9ca3af;
  margin-top: 2rem;
}

.job-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.profile-job-card {
  background: white;
  padding: 1.2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.profile-job-info h3 {
  margin: 0 0 0.3rem;
  color: #111827;
}

.profile-job-price {
  font-weight: 600;
  color: #2563eb;
  margin: 0.3rem 0;
}

.profile-job-accepted {
  font-size: 0.85rem;
  color: #6b7280;
  margin: 0;
}

.status {
  display: inline-block;
  padding: 0.15rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status-open {
  background: #dbeafe;
  color: #1d4ed8;
}

.status-accepted {
  background: #fef3c7;
  color: #92400e;
}

.status-completed {
  background: #dcfce7;
  color: #15803d;
}

.status-cancelled {
  background: #fee2e2;
  color: #dc2626;
}

.profile-job-actions {
  display: flex;
  gap: 0.5rem;
}

.complete-btn {
  padding: 0.5rem 1rem;
  background: #16a34a;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
}

.complete-btn:hover {
  background: #15803d;
}

.delete-btn {
  padding: 0.5rem 1rem;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
}

.delete-btn:hover {
  background: #b91c1c;
}

.message-btn {
  padding: 0.5rem 1rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 600;
}

.message-btn:hover {
  background: #1d4ed8;
}

.economy-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 2rem;
}

.economy-card {
  padding: 1.5rem;
  border-radius: 10px;
  text-align: center;
}

.economy-card.income {
  background: #dcfce7;
}

.economy-card.expenses {
  background: #fee2e2;
}

.economy-card h3 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  color: #374151;
}

.economy-amount {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  color: #111827;
}

.stripe-placeholder {
  text-align: center;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 10px;
  border: 2px dashed #d1d5db;
}

.stripe-placeholder p {
  color: #6b7280;
  margin-bottom: 1rem;
}

.stripe-btn {
  padding: 0.7rem 1.5rem;
  background: #6366f1;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: not-allowed;
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/Profile.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".profile-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.profile-container h1 {\n  color: #1e3a5f;\n  margin-bottom: 0.3rem;\n}\n\n.profile-email {\n  color: #6b7280;\n  margin-bottom: 1.5rem;\n}\n\n.login-prompt {\n  text-align: center;\n  margin-top: 3rem;\n  font-size: 1.1rem;\n  color: #6b7280;\n}\n\n.login-prompt .link {\n  color: #2563eb;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.profile-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid #e5e7eb;\n  margin-bottom: 1.5rem;\n}\n\n.profile-tabs button {\n  padding: 0.7rem 1.2rem;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: #6b7280;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: color 0.2s;\n}\n\n.profile-tabs button.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n  font-weight: 600;\n}\n\n.profile-tabs button:hover {\n  color: #111827;\n}\n\n.tab-content {\n  min-height: 200px;\n}\n\n.empty-text {\n  text-align: center;\n  color: #9ca3af;\n  margin-top: 2rem;\n}\n\n.job-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.profile-job-card {\n  background: white;\n  padding: 1.2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.profile-job-info h3 {\n  margin: 0 0 0.3rem;\n  color: #111827;\n}\n\n.profile-job-price {\n  font-weight: 600;\n  color: #2563eb;\n  margin: 0.3rem 0;\n}\n\n.profile-job-accepted {\n  font-size: 0.85rem;\n  color: #6b7280;\n  margin: 0;\n}\n\n.status {\n  display: inline-block;\n  padding: 0.15rem 0.6rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.status-open {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.status-accepted {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-completed {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.status-cancelled {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.profile-job-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.complete-btn {\n  padding: 0.5rem 1rem;\n  background: #16a34a;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.complete-btn:hover {\n  background: #15803d;\n}\n\n.delete-btn {\n  padding: 0.5rem 1rem;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.delete-btn:hover {\n  background: #b91c1c;\n}\n\n.message-btn {\n  padding: 0.5rem 1rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.message-btn:hover {\n  background: #1d4ed8;\n}\n\n.economy-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.economy-card {\n  padding: 1.5rem;\n  border-radius: 10px;\n  text-align: center;\n}\n\n.economy-card.income {\n  background: #dcfce7;\n}\n\n.economy-card.expenses {\n  background: #fee2e2;\n}\n\n.economy-card h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1rem;\n  color: #374151;\n}\n\n.economy-amount {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0;\n  color: #111827;\n}\n\n.stripe-placeholder {\n  text-align: center;\n  padding: 2rem;\n  background: #f9fafb;\n  border-radius: 10px;\n  border: 2px dashed #d1d5db;\n}\n\n.stripe-placeholder p {\n  color: #6b7280;\n  margin-bottom: 1rem;\n}\n\n.stripe-btn {\n  padding: 0.7rem 1.5rem;\n  background: #6366f1;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
